import React from 'react'

import Image from 'shared/components/common/Image'
import { t } from 'src/translations'

type Props = {
  errorCode?: string
  errorMessage: string
  showCta?: boolean
  isEditor?: boolean
}

const containerStyle = {
  position: 'relative' as const,
  width: '100%',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const imageStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1
}

const contentStyle = {
  position: 'absolute' as const,
  top: '35%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  gap: '16px',
  padding: '32px',
  backgroundColor: 'white',
  borderRadius: '12px',
  border: '1px solid #e0e0e0',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  minWidth: '300px',
  zIndex: 2
}

const buttonStyle = {
  backgroundColor: '#2B4FB9',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '32px',
  cursor: 'pointer',
  fontSize: '14pt',
  width: '250px',
  minWidth: '250px',
  fontWeight: 'semibold'
}

const errorMessageStyle = {
  textAlign: 'center' as const,
  fontSize: '18px',
  fontWeight: '400',
  color: '#333',
  lineHeight: '1.5',
  margin: '0'
}

const BaseErrorComponent = ({
  errorMessage,
  errorCode,
  showCta = true,
  isEditor
}: Props) => {
  // if the page is in editor mode, show the revert modal
  React.useEffect(() => {
    if (isEditor) {
      window.dispatchEvent(
        new CustomEvent('show-revert-modal', { detail: { refresh: true } })
      )
    }
  }, [isEditor])

  return (
    <div style={containerStyle}>
      <div style={imageStyle}>
        <Image src={'icons/error_question_mark.svg'} alt='' />
      </div>
      {!isEditor && (
        <div style={contentStyle}>
          {errorCode && <p style={errorMessageStyle}>{errorCode}</p>}
          <p style={errorMessageStyle}>{errorMessage}</p>
          {showCta && (
            <button
              style={buttonStyle}
              onClick={() => {
                window?.location?.reload?.()
              }}
            >
              {t('base-error.reload-page')}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default BaseErrorComponent
